export default "__VITE_ASSET__Bl2W43wS__"